module.exports = __webpack_public_path__ + "assets/images/green-xmas-scrollyimage2.jpg?v=d4b8fd1b";